import { useSelector } from 'react-redux';

import useCartStore from './useCartStore';

const useCart = (item) => {
  const { addItemsToCart, removeItemsToCart, showModalNoPurchasable, /*showModalNoPurchasableDJVersion,*/ showModalNoPurchasableDJExlusives } = useCartStore();
  const counter = useSelector(state => state.cartCounter)
  const isConnected = useSelector(state => state.isConnected)
  const storePopup = useSelector(state => state.storePopup)
  const cartItems = useSelector( state => state.cartItems );
  const isInCart = cartItems.some( id => id === item.id);

  const addToCart = () => {
    if (isConnected) {
      if ((item.genre && item.genre.slug && item.genre.slug === 'dj-exclusives')) {
        showModalNoPurchasableDJExlusives();
      } else if (item.is_dj_edit || (item.genre && item.genre.slug === 'dj-edits')) { 
        // if (item.is_dj_version) {
        //   showModalNoPurchasableDJVersion();
        // } else {
          showModalNoPurchasable();
        // }
      } else {
        addItemsToCart([item.id], [], counter);
      }
    } else {
      storePopup.cart();
    }
  }

  const removeToCart = (afterCallback = null) => {
    if (item && item.id && item.cartItemID) {
      removeItemsToCart([{ itemID: item.id, cartItemID: item.cartItemID }], afterCallback);
    }
  }

  const storeX = {
    addToCart,
    removeToCart,
    isInCart
  };

  return storeX;
};

export default useCart;
